import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import profileicon from '../../../assets/images/profile.png';
import teamLogo from '../../../assets/images/coachTeamLogo.png';
import { normalizePlayerClass } from '../../../utils/normalizePlayerClass';

export const FollowedProfiles = ({
  followedPlayers = [],
  followedTeams = [],
  topPlayers = [],
  loading = false,
  teamsLoading = false,
  onTeamSelect = () => { },
  onTabChange = () => { },
  selectedTeam = null,
  onUnfollowPlayer = () => { },
  onUnfollowTeam = () => { }
}) => {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const [activeTab, setActiveTab] = useState('players'); // 'players' or 'teams'
  console.log(followedPlayers, "followedPlayers");
  console.log(followedTeams, "followedTeams");
  // Determine which data to display
  const hasFollowedPlayers = followedPlayers && followedPlayers.length > 0;
  const hasFollowedTeams = followedTeams && followedTeams.length > 0;
  // const profiles = hasFollowedPlayers ? followedPlayers : topPlayers; // Commented: Show only followed players
  const profiles = activeTab === 'players'
    ? (hasFollowedPlayers ? followedPlayers : [])
    : (hasFollowedTeams ? followedTeams : []);
console.log(profiles, "profiles")
  const currentLoading = activeTab === 'players' ? loading : teamsLoading;
  console.log(hasFollowedPlayers, "hasFollowedPlayers")
  console.log(hasFollowedTeams, "hasFollowedTeams")
  // Update arrow visibility when profiles change
  useEffect(() => {
    handleScroll();
  }, [profiles]);

  // Reset scroll position when tab changes
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = 0;
    }
  }, [activeTab]);

  // Auto-select first team when switching to teams tab
  useEffect(() => {
    if (activeTab === 'teams' && hasFollowedTeams && !selectedTeam) {
      onTeamSelect(followedTeams[0]);
    }
  }, [activeTab, hasFollowedTeams, followedTeams, selectedTeam, onTeamSelect]);

  // Debug: Log when selectedTeam changes
  useEffect(() => {
    console.log('FollowedProfiles: selectedTeam changed to:', selectedTeam);
  }, [selectedTeam]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    onTabChange(tab);
  };

  const handlePlayerClick = (player) => {
    const playerId = player._id;
    navigate(`/coach/player/${playerId}`, {
      state: {
        from: 'dashboard',
        playerData: {
          ...player,
          team: player.team
        }
      }
    });
  };

  const handleTeamSelect = (team) => {
    console.log('Team card clicked:', team);
    console.log('Calling onTeamSelect with team:', team._id, team.name);
    onTeamSelect(team);
  };

  const handleViewTeam = (e, team) => {
    e.stopPropagation();
    const teamId = team._id;
    navigate(`/coach/team/${teamId}`, {
      state: {
        teamData: team
      }
    });
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  return (
    <div className=" p-6 ">
      {/* Header */}
      <div className="mb-4">
        <h3 className="text-jp-ink text-lg font-bold uppercase mb-3 text-left">
          FOLLOWED PROFILES
        </h3>
        <div className="flex items-center gap-2">
          {/* Players Tab */}
          <button
            onClick={() => handleTabChange('players')}
            className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${activeTab === 'players'
              ? 'bg-cyan-500 hover:bg-cyan-600 border-cyan-500 text-white'
              : 'bg-jp-section hover:bg-jp-line border-jp-line text-jp-ink'
              }`}
          >
            {followedPlayers.length} Following players
          </button>

          {/* Teams Tab */}
          <button
            onClick={() => handleTabChange('teams')}
            className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${activeTab === 'teams'
              ? 'bg-cyan-500 hover:bg-cyan-600 border-cyan-500 text-white'
              : 'bg-jp-section hover:bg-jp-line border-jp-line text-jp-ink'
              }`}
          >
            {followedTeams.length} Following teams
          </button>
        </div>
      </div>

      {/* Scrollable Cards Container with Overlay Arrows */}
      <div className="relative group">
        {/* Left Arrow - Overlay */}
        {showLeftArrow && (
          <button
            onClick={() => scroll('left')}
            className="absolute left-2 top-1/2 -translate-y-1/2 z-10 p-3 bg-jp-card hover:bg-jp-section rounded-full text-jp-ink transition-all opacity-0 group-hover:opacity-100 shadow-lg border border-jp-line"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}

        {/* Right Arrow - Overlay */}
        {showRightArrow && (
          <button
            onClick={() => scroll('right')}
            className="absolute right-2 top-1/2 -translate-y-1/2 z-10 p-3 bg-jp-card hover:bg-jp-section rounded-full text-jp-ink transition-all opacity-0 group-hover:opacity-100 shadow-lg border border-jp-line"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        )}

        {/* Scrollable Cards */}
        <div
          ref={scrollRef}
          onScroll={handleScroll}
          className="flex gap-4 overflow-x-auto scrollbar-hide pb-2"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {currentLoading ? (
            <div className="flex items-center justify-center w-full py-8">
              <div className="w-8 h-8 border-2 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : profiles && profiles.length > 0 ? (
            profiles.map((profile) => {
              if (activeTab === 'players') {
                // Render Player Card
                const playerName = profile.name || `${profile.firstName || ''} ${profile.lastName || ''}`.trim() || 'Unknown Player';
                const position = profile.position || 'N/A';
                const teamName = profile.team?.name || profile.team || 'N/A';
                const profileImage = profile.profileImage || profileicon;
                const jerseyNumber = profile.jerseyNumber || null;
                const playerClass = normalizePlayerClass(profile.playerClass) || '';

                return (
                  <div
                    key={profile._id}
                    onClick={() => handlePlayerClick(profile)}
                    className="flex-shrink-0 w-48 bg-jp-card rounded-xl overflow-hidden border border-jp-line hover:border-jp-accent/50 transition-colors relative cursor-pointer group"
                  >
                    {/* Player Image */}
                    <div className="h-52 bg-jp-section relative">
                      <img
                        src={profileImage}
                        alt={playerName}
                        className="w-full h-full object-fill"
                        onError={(e) => {
                          e.target.src = profileicon;
                        }}
                      />

                      {/* Info Overlay */}
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/80 to-transparent p-3 text-left">
                        <h4 className="text-white font-medium text-base truncate">{playerName}</h4>
                        {/* <p className="text-jp-muted text-sm mb-0.5 truncate">{position}</p> */}
                        <p className="text-white text-xs font-normal truncate whitespace-nowrap overflow-hidden">
                          {jerseyNumber && `#${jerseyNumber}`} {position} {playerClass}
                        </p>
                      </div>

                      {/* Unfollow Icon - Bottom Right */}
                      <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onUnfollowPlayer(profile._id);
                          }}
                          className="w-8 h-8 bg-jp-section hover:bg-jp-line rounded-full flex items-center justify-center transition-colors shadow-lg"
                          title="Unfollow"
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-jp-ink">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              } else {
                // Render Team Card
                const teamNameStr = profile.name || profile.teamName || 'Unknown Team';
                const division = profile.division || 'N/A';
                const location = profile.location || 'N/A';
                const teamLogoSrc = profile.logo || teamLogo;
                const isSelected = selectedTeam?._id === profile._id;

                return (
                  <div
                    key={profile._id}
                    onClick={() => handleTeamSelect(profile)}
                    className={`flex-shrink-0 w-48 bg-jp-card rounded-xl overflow-hidden border transition-colors relative cursor-pointer group ${isSelected
                      ? 'border-cyan-500 ring-2 ring-cyan-500/50'
                      : 'border-jp-line hover:border-jp-accent/50'
                      }`}
                  >
                    {/* View Team Button - Top Right */}
                    <div className="absolute top-2 left-1/2 -translate-x-1/2 z-10 whitespace-nowrap">
                      <button
                        onClick={(e) => handleViewTeam(e, profile)}
                        className="px-3 py-1.5 bg-[linear-gradient(2deg,steelblue,grey,steelblue,transparent)] hover:bg-cyan-600 text-white text-xs font-semibold rounded-md transition-colors shadow-lg"
                      >
                        View Team
                      </button>
                    </div>

                    {/* Team Image */}
                    <div className="h-52 bg-jp-section relative flex items-center justify-center ">
                      <img
                        src={teamLogoSrc}
                        alt={teamNameStr}
                        className="w-34 h-34 object-cover mb-5"
                        onError={(e) => {
                          e.target.src = teamLogo;
                        }}
                      />

                      {/* Info Overlay */}
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/80 to-transparent p-2 ">
                        <h4 className="text-white font-medium text-base mb-0.5">{teamNameStr}</h4>
                        {/* <p className="text-jp-muted text-sm mb-0.5 truncate">{division}</p>
                        <p className="text-jp-muted text-sm truncate">{location}</p> */}
                      </div>

                      {/* Unfollow Icon - Bottom Right */}
                      <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onUnfollowTeam(profile._id);
                          }}
                          className="w-8 h-8 bg-jp-section hover:bg-jp-line rounded-full flex items-center justify-center transition-colors shadow-lg"
                          title="Unfollow"
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-jp-ink">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              }
            })
          ) : (
            <div className="flex flex-col items-center justify-center w-full py-12 text-center">
              <svg className="w-16 h-16 text-jp-muted/70 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {activeTab === 'players' ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                )}
              </svg>
              <p className="text-jp-muted text-lg font-medium mb-2">
                {activeTab === 'players' ? 'No followed players yet' : 'No followed teams yet'}
              </p>
              <p className="text-jp-muted text-sm max-w-md">
                {activeTab === 'players'
                  ? 'You have not followed any players yet. To see and match the data of players, follow them first from the Statistics section.'
                  : 'You have not followed any teams yet. To see teams, follow them first from the Team section.'}
              </p>
            </div>
          )}
        </div>
      </div>

      {/* CSS to hide scrollbar */}
      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};
